import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontCondensed } from "@fdr/static-ui/Typography";
import { buildText } from "@fdr/atomic-ui/_atoms/Text";
import { DerbyLabelType } from "./types";

export const Text = styled(buildText())`
  margin-left: 8px;
`;

const commonLabelStyles = css`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  text-decoration: none;
  outline: none;
  width: 100%;
  font-family: ${fontCondensed};
  font-weight: 400;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: 5px 0;
  background-color: ${buildColor("blue", "950")};
  border-radius: 2px;
`;

const getLabelStyles = (derbyLabelType: DerbyLabelType) =>
  derbyLabelType === "live"
    ? css`
        color: ${buildColor("white", "100")};
      `
    : css`
        color: ${buildColor("yellow", "500")};
        border: solid 1px ${buildColor("yellow", "500")};
      `;

export const Container = styled.div<{
  derbyLabelType: DerbyLabelType;
}>`
  ${commonLabelStyles}
  ${({ derbyLabelType }) => getLabelStyles(derbyLabelType)}
`;
